import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Field, Section } from '../../model/eform-type';
import { Toast } from '../../../shared/toast/toast';
import { TranslateService } from '@ngx-translate/core';
import { Address } from '../../form-control/properties/address-properties/address-properties.component';
import { GroupName } from '../field-type/name/name.component';
import { EformAPI } from '../../e-form.api';
import { IdexService } from '../../../idex.service';
import { EformService } from "../../service/eform.service";
import { ActivatedRoute } from '@angular/router';
import { TaskAttribute } from 'app/e-signature/create-task/create-task.type';
import { DynamicFormBuilderService } from './dynamic-form-builder.service';

@Component({
   selector: 'app-dynamic-form-builder',
   templateUrl: './dynamic-form-builder.component.html',
   styleUrls: ['./dynamic-form-builder.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicFormBuilderComponent implements OnInit, AfterViewInit {

   @Input() fields: Field[];
   @Input() sections: Section[];
   @Input() isFormName: boolean;
   @Input() firstSignField: any;
   @Input() isPreview: boolean;
   @Input() isViewOnly: boolean;
   @Input() previewClass: boolean;
   @Input() taskAttribute: TaskAttribute;
   @Input() isStartFlow: boolean;
   @Output() checkSubmit = new EventEmitter();
   @Output() selectSig = new EventEmitter();
   @Output() showSignTool = new EventEmitter();
   @Output() checkSaveSend = new EventEmitter();
   @Output() signAllForm = new EventEmitter();

   field: any[] = [];
   form: FormGroup;
   displayValueTrue: any;
   checkValidate = false;
   fieldName: any[] = [];
   fieldNameArray: any[] = [];
   fieldNames: any[] = [];
   classes: any;
   lang: any;
   fNameValue: any;
   lNameValue: any;
   imageNoSignaturePreview = 'assets/images/no_signature_form.png';
   imageSignaturePreview = 'assets/images/no_signature.png';
   imageInitializePreview = 'assets/images/no_initials.png';
   errorMessage: any;
   isSignDoc = false;
   isCreateFile = false;
   sectionList: any[] = [];

   constructor(
      private toast: Toast, private api: EformAPI,
      private translate: TranslateService,
      public service: IdexService,
      public eformService: EformService,
      private router: ActivatedRoute,
      private changeDetectorRefs: ChangeDetectorRef,
      private dynamicFormBuilderService: DynamicFormBuilderService
   ) {
      if (this.router.snapshot.url[0] && this.router.snapshot.url[0].path === 'signdoc') {
         this.isSignDoc = true;
      }
      const param = this.router.snapshot.queryParamMap.get('isCreateFile');
      this.isCreateFile = param ? Boolean(param).valueOf() : false;
      this.eformService.changeSignatureBackground.subscribe(data => {
         if (data) {
            this.form.controls[data].setValue(null);
         }
      })
   }

   ngOnInit() {
      this.lang = localStorage.getItem('lang');
      this.setData(this.sections);
      let indexForm = this.taskAttribute?.docList.findIndex(o => o.docName.toLowerCase().endsWith('.zdox'));
      const currentSigner = this.taskAttribute?.apvLevel.find(signer => signer.order === this.taskAttribute.currentLevel);
      const taskContact = currentSigner?.signerList.find(element => element.signerEmail === this.service.user.email || element?.reassignEmail === this.service.user.email);

      this.sections.forEach(section => {
         let isSign = false;
         let key = section.key;

         section.fields.forEach((field) => {
            if (currentSigner && taskContact && this.taskAttribute?.docList[indexForm]?.signItems) {
               const haveToSignItem = this.taskAttribute?.docList[indexForm]?.signItems.find(signItem => (signItem.taskContactId === taskContact?.taskContactId || signItem.signer === this.service.user.email)
                  && signItem.fieldName === field.fieldName && signItem.stepOrder === this.taskAttribute.currentLevel && signItem.taskContactId === taskContact?.taskContactId);

               if (haveToSignItem) {
                  isSign = true;
               }

            }
         });
         const data = {
            key,
            isSign,
         };
         this.sectionList.push(data)

      });
      this.createSignature();
      if (this.firstSignField) {
         this.selectSignature(this.firstSignField, 'init');
      }
   }

   createSignature() {
      this.service.getProfile()
         .subscribe((data: any) => {
            this.fNameValue = data.fName;
            this.lNameValue = data.lName;
         }, error => {
            this.errorMessage = error;
         });
   }

   setSection(section) {
      const { en, th, cn } = section;
      switch (this.lang) {
         case 'en':
            return en !== undefined && en !== '' ? en : th || null;
         case 'th':
            return th !== undefined && th !== '' ? th : en || null;
         case 'cn':
            return cn !== undefined && cn !== '' ? cn : th || en || null;
         default:
            return th !== undefined && th !== '' ? th : en || null;
      }
   }


   setData(data: any) {
      const fieldsCtrl = {};
      let regex = '';
      this.sections = data;
      if (this.sections !== undefined) {
         const sectionsLength = this.sections.length;
         for (let index = 0; index < sectionsLength; index++) {
            const fieldsLength = this.sections[index].fields.length;
            for (let index_field = 0; index_field < fieldsLength; index_field++) {
               this.field = this.sections[index].fields;
               this.form = new FormGroup({
                  field: new FormControl(JSON.stringify(this.field))
               });
               let index_fieldName = 0;
               this.fieldNames = [];
               this.fieldNameArray = [];
               for (const f of this.field) {
                  if (f.fieldName !== '') {
                     this.fieldNames[index_fieldName] = f.fieldName;
                  } else {
                     this.fieldNames[index_fieldName] = f.fieldNameEmpty;
                  }
                  switch (f.fieldType) {
                     case 'f-textbox': {
                        if (f.display) {
                           fieldsCtrl[this.fieldNames[index_fieldName]] = f.required ? new FormControl('', [Validators.required, Validators.pattern(f.regex), Validators.maxLength(f.maxLength)])
                              : new FormControl('', Validators.pattern(f.regex));
                        } else {
                           fieldsCtrl[this.fieldNames[index_fieldName]] = new FormControl(false, Validators.pattern(f.regex));
                        }

                        this.fieldNameArray[index_fieldName] = { name: this.fieldNames[index_fieldName], type: '' };
                        break;
                     }
                     case 'f-radio': {
                        const opts = {};
                        if (f.display) {
                           this.getRadioOption(f.radioOption);
                           switch (f.type) {
                              case 'checkbox': {
                                 opts[this.displayValueTrue] = new FormControl('');
                                 fieldsCtrl[this.fieldNames[index_fieldName]] = new FormGroup(opts);
                                 break;
                              }
                              default: {
                                 fieldsCtrl[this.fieldNames[index_fieldName]] = f.required ? new FormControl('', [Validators.required]) : new FormControl('');
                                 break;
                              }
                           }

                        } else {
                           fieldsCtrl[this.fieldNames[index_fieldName]] = new FormControl(false);
                        }

                        this.fieldNameArray[index_fieldName] = { name: this.fieldNames[index_fieldName], type: '' };
                        break;
                     }
                     case 'f-choice': {
                        const opts = {};
                        if (f.display) {
                           switch (f.type) {
                              case 'checkbox': {
                                 let i = 0;
                                 for (const otp of f.choices) {
                                    const value = (typeof otp.value === 'boolean') ? otp.value : false;
                                    opts[f.fieldName + '_' + i] = f.required ? new FormControl(value, [Validators.required])
                                       : new FormControl('');
                                    i++;
                                 }
                                 fieldsCtrl[this.fieldNames[index_fieldName]] = new FormGroup(opts, this.validateCheckbox(f.required));
                                 break;
                              }
                              default: {
                                 fieldsCtrl[this.fieldNames[index_fieldName]] = f.required ? new FormControl('', [Validators.required])
                                    : new FormControl('');
                                 break;
                              }
                           }
                        } else {
                           fieldsCtrl[this.fieldNames[index_fieldName]] = new FormControl(false);
                        }
                        this.fieldNameArray[index_fieldName] = { name: this.fieldNames[index_fieldName], type: '' };
                        break;
                     }
                     case 'f-email': {
                        regex = '^(?!.*\\.{2})[\\w-]+(\\.[\\w-]+)*@(?!.*\\_)[\\w-]+(\\.[\\w-]+)*\\.[\\w-]{2,4}$';
                        if (f.display) {
                           fieldsCtrl[this.fieldNames[index_fieldName]] = f.required ? new FormControl('', [Validators.required, Validators.pattern(regex)])
                              : new FormControl('', Validators.pattern(regex));
                        } else {
                           fieldsCtrl[this.fieldNames[index_fieldName]] = new FormControl('', Validators.pattern(regex));
                        }
                        this.fieldNameArray[index_fieldName] = { name: this.fieldNames[index_fieldName], type: '' };
                        break;
                     }
                     case 'f-website': {
                        regex = '(?:http[s]?|ftp):\/\/[\\w_-]+(?:\\.[\\w_-]+)+(?:[\\w.,@?^=%&:/~+#-]*[\\w@?^=%&/~+#-])?';
                        if (f.display) {
                           fieldsCtrl[this.fieldNames[index_fieldName]] = f.required ? new FormControl('', [Validators.required, Validators.pattern(regex)])
                              : new FormControl('', Validators.pattern(regex));
                        } else {
                           fieldsCtrl[this.fieldNames[index_fieldName]] = new FormControl(false, Validators.pattern(regex));
                        }
                        this.fieldNameArray[index_fieldName] = { name: this.fieldNames[index_fieldName], type: '' };
                        break;
                     }
                     case 'f-address': {
                        if (f.display) {
                           fieldsCtrl[Address.Address1 + '-' + this.fieldNames[index_fieldName]] = (f.address1.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                           fieldsCtrl[Address.Address2 + '-' + this.fieldNames[index_fieldName]] = (f.address2.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                           if (f.type === 'local') {
                              fieldsCtrl[Address.Province + '-' + this.fieldNames[index_fieldName]] = (f.province.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                              fieldsCtrl[Address.District + '-' + this.fieldNames[index_fieldName]] = (f.district.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                              fieldsCtrl[Address.SubDistrict + '-' + this.fieldNames[index_fieldName]] = (f.subDistrict.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                              fieldsCtrl[Address.ZipCode + '-' + this.fieldNames[index_fieldName]] = (f.zipCode.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                           } else {
                              fieldsCtrl[Address.City + '-' + this.fieldNames[index_fieldName]] = (f.city.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                              fieldsCtrl[Address.State + '-' + this.fieldNames[index_fieldName]] = (f.state.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                              fieldsCtrl[Address.Postal + '-' + this.fieldNames[index_fieldName]] = (f.postal.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                              fieldsCtrl[Address.Country + '-' + this.fieldNames[index_fieldName]] = (f.country.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                           }
                        } else {
                           fieldsCtrl[Address.Address1 + '-' + this.fieldNames[index_fieldName]] = new FormControl(false);
                           fieldsCtrl[Address.Address2 + '-' + this.fieldNames[index_fieldName]] = new FormControl(false);
                           if (f.type === 'local') {
                              fieldsCtrl[Address.Province + '-' + this.fieldNames[index_fieldName]] = new FormControl(false);
                              fieldsCtrl[Address.District + '-' + this.fieldNames[index_fieldName]] = new FormControl(false);
                              fieldsCtrl[Address.SubDistrict + '-' + this.fieldNames[index_fieldName]] = new FormControl(false);
                              fieldsCtrl[Address.ZipCode + '-' + this.fieldNames[index_fieldName]] = new FormControl(false);
                           } else {
                              fieldsCtrl[Address.City + '-' + this.fieldNames[index_fieldName]] = new FormControl(false);
                              fieldsCtrl[Address.State + '-' + this.fieldNames[index_fieldName]] = new FormControl(false);
                              fieldsCtrl[Address.Postal + '-' + this.fieldNames[index_fieldName]] = new FormControl(false);
                              fieldsCtrl[Address.Country + '-' + this.fieldNames[index_fieldName]] = new FormControl(false);
                           }
                        }
                        this.fieldNameArray[index_fieldName] = { name: this.fieldNames[index_fieldName], type: f.type };
                        break;
                     }
                     case 'f-name': {
                        if (f.display) {
                           fieldsCtrl[GroupName.Title + this.fieldNames[index_fieldName]] = (f.title.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                           fieldsCtrl[GroupName.Title + 'Other' + this.fieldNames[index_fieldName]] = (f.title.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                           fieldsCtrl[GroupName.Name + this.fieldNames[index_fieldName]] = (f.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                           fieldsCtrl[GroupName.Middle + this.fieldNames[index_fieldName]] = (f.middleName.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                           fieldsCtrl[GroupName.Surname + this.fieldNames[index_fieldName]] = (f.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                           fieldsCtrl[GroupName.Initial + this.fieldNames[index_fieldName]] = (f.initial.required) ? new FormControl('', [Validators.required]) : new FormControl('');
                        } else {
                           fieldsCtrl[GroupName.Title + this.fieldNames[index_fieldName]] = new FormControl(false);
                           fieldsCtrl[GroupName.Title + 'Other' + this.fieldNames[index_fieldName]] = new FormControl(false);
                           fieldsCtrl[GroupName.Name + this.fieldNames[index_fieldName]] = new FormControl(false);
                           fieldsCtrl[GroupName.Middle + this.fieldNames[index_fieldName]] = new FormControl(false);
                           fieldsCtrl[GroupName.Surname + this.fieldNames[index_fieldName]] = new FormControl(false);
                           fieldsCtrl[GroupName.Initial + this.fieldNames[index_fieldName]] = new FormControl(false);
                        }
                        this.fieldNameArray[index_fieldName] = { name: this.fieldNames[index_fieldName], type: 'name' };
                        break;
                     }
                     default: {
                        if (f.display) {
                           fieldsCtrl[this.fieldNames[index_fieldName]] = f.required ? new FormControl('', [Validators.required])
                              : new FormControl('');
                        } else {
                           fieldsCtrl[this.fieldNames[index_fieldName]] = new FormControl(false);
                        }
                        this.fieldNameArray[index_fieldName] = { name: this.fieldNames[index_fieldName], type: '' };
                        break;
                     }
                  }
                  index_fieldName++;
               }
               this.sections[index].fieldNames = this.fieldNames;
               this.sections[index].fieldIndex = this.fieldNameArray;
            }
         }
         this.form = new FormGroup(fieldsCtrl);
      } else {
         this.form = new FormGroup({});
      }
   }

   getRadioOption(field) {
      switch (field) {
         case 0:
            this.displayValueTrue = 'yes';
            break;
         case 1:
            this.displayValueTrue = 'true';
            break;
         case 2:
            this.displayValueTrue = 'enable';
            break;
         case 3:
            this.displayValueTrue = 'on';
            break;
         case 4:
            this.displayValueTrue = 'read';
            break;
         default:
            this.displayValueTrue = 'yes';
            break;
      }

   }

   onSubmit(isPreview?: boolean) {
      const replaceUndefinedEmptyString = (obj) => {
         for (let key in obj) {
            if (obj[key] === undefined) {
               obj[key] = "";
               delete obj[key];
            } else if (typeof obj[key] === 'object' && obj[key] !== null) {
               replaceUndefinedEmptyString(obj[key]);
            }
         }
      };
      replaceUndefinedEmptyString(this.form.value);
      if (!isPreview) {
         this.eformService.storeValue(JSON.stringify(this.form.value));
      }

      if (!this.findValidControls()) {
         this.translate.get('eform.submit.error').subscribe((msg) => {
            this.toast.error(msg);
         });
      }
      this.checkValidate = true;
      this.checkSubmit.emit(this.findValidControls());
   }



   /**
    * ตรวจสอบว่า Form มี status เป็น VALID หรือไม่
    *
    * Form มีได้ 4 สถานะคือ VALID, INVALID, PENDING, DISABLED
    * @see https://angular.dev/api/forms/FormControlStatus
    *
    * @returns {boolean} FormControlStatus === 'VALID'
    */
   findValidControls(signList?: any, isSign?: boolean, isCheck?: boolean, clear?: boolean) {
      let reqFlag: boolean;
      const replaceUndefinedEmptyString = (obj) => {
         for (let key in obj) {
            if (obj[key] === undefined) {
               obj[key] = "";
               delete obj[key];
            } else if (typeof obj[key] === 'object' && obj[key] !== null) {
               replaceUndefinedEmptyString(obj[key]);
            }
         }
      };

      replaceUndefinedEmptyString(this.form.value);

      if (isSign) {
         let reqList: any = [];
         for (const sec of this.sections) {
            for (const field of sec.fields) {
               if (field.display && field.required && !isCheck) {
                  if (this.form.get(field.fieldName)?.status === 'INVALID') {
                     reqList.push(field)
                  }
               }
            }
         }
         reqFlag = reqList.every((field) => field.fieldType === 'f-signature')
      }

      if (signList) {
         this.checkValidate = true;
         this.changeDetectorRefs.detectChanges();
         if (clear) {
            return;
         }
         if (isSign) {
            this.checkSaveSend.emit(this.findValidControls(undefined, true));
         } else {
            this.checkSaveSend.emit(this.findValidControls(undefined, true, true));
         }
      } else {
         for (const sec of this.sections) {
            for (const field of sec.fields) {
               if (field.required && field.type === 'signature') {
                  if (!this.form.controls[field.fieldName].value) {
                     this.checkSaveSend.emit(false);
                     return false;
                  }
               }
            }
         }
         this.eformService.storeValue(JSON.stringify(this.form.value));
      }

      if (this.form.valid) {
         this.checkSaveSend.emit(true);
         return true;
      } else {
         if (isSign) {
            this.eformService.storeValue((this.form.value));
            this.checkValidate = true;
            if (reqFlag || (reqFlag && isCheck)) {
               return true;
            }
         }
         this.checkSaveSend.emit(false);
         return false;
      }
   }

   /**
    * เปิดการแสดง error 'ไม่กรอกค่าใน required field (ถ้ามี)' \
    * Enable showing error (if any) when the field is required and empty
    */
   public enableShowFieldEmptyError() {
      this.dynamicFormBuilderService.EnableShowFieldEmptyError();
   }

   /**
    * เช็คว่าในบรรดา required field ทั้งหมดที่ยังไม่ได้กรอกค่า มีแค่เฉพาะ field 'signature' หรือไม่
    * - `True` = มี field ที่ยังไม่ได้กรอกค่า และ ทุก field ที่ยังไม่ได้กรอกค่าเป็น field 'signature' เท่านั้น
    * - `False` = ไม่มี field ที่ยังไม่ได้กรอกค่า หรือ มี field ที่ยังไม่ได้กรอกค่าแต่มี field ที่ไม่ใช่ field 'signature'
    *
    * (ทำไว้ช่วยเช็คเพื่อแสดง error message ตามเงื่อนไขใน ZE-4836)
    */
   public checkIfInvalidRequiredFieldsOnlySignatures(): boolean {
      const invalidRequiredFields = this.getInvalidRequiredFields(this.form);
      for (const invalidRequiredField of invalidRequiredFields) {
         const sectionOfInvalidRequiredSignatureField = this.sections.find((section) =>
            section.fields.some(
               (field) =>
                  field.fieldName === invalidRequiredField &&
                  field.required &&
                  field.display &&
                  field.fieldType === 'f-signature'
            )
         );
         if (!sectionOfInvalidRequiredSignatureField) {
            return false;
         }
      }
      return true;
   }


   /**
    * จาก form ที่รับมา  return list ของชื่อ field ที่ required และยังไม่ได้กรอกค่า/มีสถานะเป็น INVALID
    */
   private getInvalidRequiredFields(form: FormGroup): string[] {
      const invalidRequiredFields: string[] = [];

      Object.keys(form.controls).forEach(key => {
         const control = form.get(key);
         if (control?.hasValidator(Validators.required) && control.status === 'INVALID') {
            invalidRequiredFields.push(key);
         }
      });

      return invalidRequiredFields;
   }

   validateSignature(signField: any[]): boolean {
      let isSignAll = true;
      if (signField) {
         for (let field of signField) {
            if (!this.form.controls[field].value) {
               isSignAll = false;
            }
         }
      }
      return isSignAll;
   }

   validateCheckbox(require: boolean): ValidatorFn {
      return function validate(formGroup: FormGroup) {
         let checked = 0;
         Object.keys(formGroup.controls).forEach(key => {
            const control = formGroup.controls[key];
            if (control.value) {
               checked++;
            }
         });
         if (require && checked < 1) {
            return {
               requireCheckboxToBeChecked: true,
            };
         }
         return null;
      };
   }

   isDisplay(section: any): boolean {
      if (section.name[this.lang] || section.description[this.lang]) {
         return true;
      }
      for (let field of section.fields) {
         if (field.display) {
            return true;
         }
      }
      return false;
   }

   selectSignature(event, type?: string) {
      let fieldName, taskContactId;
      fieldName = event.fieldName;
      taskContactId = event.taskContactId;
      this.selectSig.emit({ fieldName, type, taskContactId });
   }

   onshowSignTool(flag) {
      this.showSignTool.emit(flag);
   }

   detectChanges(): void {
      this.changeDetectorRefs.detectChanges();
   }

   enableAllFields() {
      for (const key of Object.keys(this.form.controls)) {
         this.form.controls[key].enable();
      }
   }

   isEmpty(value: any): boolean {
      return value == null || value === '';
   }

   ngAfterViewInit(): void {
      if (this.isViewOnly) {
         this.form.disable();
      }
      this.changeDetectorRefs.detectChanges();
   }

   autoSignAllForm(): void {
      this.signAllForm.emit();
   }

   async isValueFormatError() {
      let hasError = false;
      const checkCurrency = (field) => {
         let isInvalidInput = false;
         let number: any;
         let value = this.form.get(field.fieldName)?.value || '';
         value = value.replace(field.currency, '')
         value = value.replace(/\s/g, '');
         value = value.replace(/,/g, '');
         value = value.replace(/ /g,'');
         value = value.replace(/^0+(?=[1-9])/g, '');
         value = value.replace(/^-?0+(?=[1-9])/g, '-');
         value = Number(value) === 0 ? '0' : value;
         if (value.indexOf('.') === -1) {
            if (isNaN(value)) {
               isInvalidInput = true;
            }
         } else {
            number = Number(Math.round((parseFloat(value) + Number.EPSILON) * 100) / 100).toFixed(2);
            if (isNaN(number)) {
               isInvalidInput = true;
            }
         }
         if (isInvalidInput) {
            this.form.get(field.fieldName).setErrors({invalid: true});
         } else {
            this.form.get(field.fieldName).setErrors(null);
         }
      };
      const checkTitleName = async (title, field) => {
         if (!title) {
            return;
         }
         let searchResult = [];
         searchResult = await this.api.getTitleName('', 'th', "1").toPromise();
         let found = false;
         if (searchResult.length > 0) {
            found = searchResult.findIndex(o => o['title'] === title.value) !== -1;
         }
         if (!found) {
            searchResult = await this.api.getTitleName('', 'en', "1").toPromise();
            if (searchResult.length > 0) {
               found = searchResult.findIndex(o => o['title'] === title.value) !== -1;
               if (!found && field.title?.include) {
                  title.setErrors({ incorrect: true });
               }
            }
         }
      };
      for (const sec of this.sections) {
         for (const field of sec.fields) {
            if (field.fieldType === 'f-name') {
               await checkTitleName(this.form.get('title' + field.fieldName), field);
               if (field.display && this.form.get('title' + field.fieldName)?.status === 'INVALID' && this.form.get('title' + field.fieldName)?.value) {
                  this.form.controls['title' + field.fieldName].markAsDirty();
                  hasError = true;
               }
               if (field.display && this.form.get('titleOther' + field.fieldName)?.status === 'INVALID' && this.form.get('titleOther' + field.fieldName)?.value) {
                  this.form.controls['titleOther' + field.fieldName].markAsDirty();
                  hasError = true;
               }
               if (field.display && this.form.get('initial' + field.fieldName)?.status === 'INVALID' && this.form.get('initial' + field.fieldName)?.value) {
                  this.form.controls['initial' + field.fieldName].markAsDirty();
                  hasError = true;
               }
            } else if (field.fieldType === 'f-currency') {
               checkCurrency(field);
               if (field.display && this.form.get(field.fieldName)?.status === 'INVALID' && this.form.get(field.fieldName)?.value) {
                  this.form.controls[field.fieldName].markAsDirty();
                  hasError = true;
               }
            } else if (field.display && this.form.get(field.fieldName)?.status === 'INVALID' && this.form.get(field.fieldName)?.value) {
               this.form.controls[field.fieldName].markAsDirty();
               hasError = true;
            }
         }
      }
      this.changeDetectorRefs.detectChanges();
      return hasError
   }
}
